import { Box, Button, Card, Chip, Divider, Typography } from "@mui/material"
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

export const FacebookPosts = () => {
    return (
        <Box
            sx={{
                backgroundColor: "#F8FAFC",
                minHeight: "100vh",
                padding: "32px",
            }}
        >
            <Box
                sx={{
                    maxWidth: "1200px",
                    margin: "0 auto",
                }}
            >
                <Box sx={{
                    boxShadow: "0px 0px 4px 0px #0000001F",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "12px",
                    padding: "20px",
                    marginBottom: "20px"
                }}>
                    {/* Facebook Page Connection Section */}
                    <Typography
                        sx={{
                            fontSize: "20px",
                            fontWeight: 600,
                            marginBottom: "20px",
                            paddingBottom: "20px",
                            borderBottom: "1px solid #C5C5C5",
                            lineHeight: "100%",
                        }}
                    >
                        Facebook Posts Management
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2 }}>

                        {/* Total Posts */}
                        <Card
                            sx={{
                                flex: 1,
                                backgroundColor: "#2FD072",
                                color: "#fff",
                                borderRadius: "10px",
                                p: 2,
                            }}
                        >
                            <Typography fontSize="14px" fontWeight={500}>
                                Total Posts
                            </Typography>
                            <Typography fontSize="36px" fontWeight={700}>
                                47
                            </Typography>
                        </Card>

                        {/* Published */}
                        <Card
                            sx={{
                                flex: 1,
                                backgroundColor: "#16AD8A",
                                color: "#fff",
                                borderRadius: "10px",
                                p: 2,
                            }}
                        >
                            <Typography fontSize="14px" fontWeight={500}>
                                Published
                            </Typography>
                            <Typography fontSize="36px" fontWeight={700}>
                                43
                            </Typography>
                        </Card>

                        {/* Failed */}
                        <Card
                            sx={{
                                flex: 1,
                                backgroundColor: "#E85151",
                                color: "#fff",
                                borderRadius: "10px",
                                p: 2,
                            }}
                        >
                            <Typography fontSize="14px" fontWeight={500}>
                                Failed
                            </Typography>
                            <Typography fontSize="36px" fontWeight={700}>
                                2
                            </Typography>
                        </Card>

                        {/* Scheduled */}
                        <Card
                            sx={{
                                flex: 1,
                                backgroundColor: "#D4C557",
                                color: "#fff",
                                borderRadius: "10px",
                                p: 2,
                            }}
                        >
                            <Typography fontSize="14px" fontWeight={500}>
                                Scheduled
                            </Typography>
                            <Typography fontSize="36px" fontWeight={700}>
                                2
                            </Typography>
                        </Card>

                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "20px", flexDirection: "column" }}>
                    <Box>
                        <Card
                            sx={{
                                width: "100%",
                                boxShadow: "0px 0px 4px 0px #0000001F",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "12px",
                                padding: "20px",
                                p: 2,
                            }}
                        >
                            {/* Header */}
                            <Box display="flex" alignItems="center" gap={2}>
                                <Box style={{
                                    width: "70px",
                                    height: "70px",
                                    borderRadius: "11px",
                                    backgroundColor: "#D9D9D9",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    image
                                </Box>
                                <Box flex={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography fontWeight={700} fontSize={16}>
                                            ✨ Premium Wireless Headphones ✨
                                        </Typography>

                                        <Chip
                                            label="Published"
                                            size="small"
                                            sx={{
                                                bgcolor: "#106C3647",
                                                color: "#106C36",
                                                fontWeight: 700,
                                                fontSize: 12,
                                                height: 26,
                                                p: 1,
                                            }}
                                        />
                                    </Box>

                                    {/* Description */}
                                    <Typography
                                        fontSize={14}
                                        fontWeight={700}
                                        mt={0.5}
                                        mb={1}
                                        lineHeight="18px"
                                    >
                                        Experience crystal-clear audio with our latest wireless headphones
                                        featuring active noise cancellation...
                                    </Typography>

                                    {/* Meta */}

                                    <Box
                                        fontWeight={600} color="#898989"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "16px",


                                        }}
                                    >
                                        {/* Date */}
                                        <Box display="flex" alignItems="center" gap="6px">
                                            <CalendarTodayOutlinedIcon sx={{ fontSize: 14 }} />
                                            <Typography fontSize={14}>
                                                Dec 11, 2025 · 10:30 AM
                                            </Typography>
                                        </Box>

                                        {/* Product */}
                                        <Box display="flex" alignItems="center" gap="6px">
                                            <Inventory2OutlinedIcon sx={{ fontSize: 14 }} />
                                            <Typography fontSize={14}>
                                                Product: Wireless Headphones
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Divider sx={{ my: 1.5 }} />

                            {/* Stats */}
                            <Box display="flex" alignItems="center" gap={2}>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <ThumbUpAltOutlinedIcon sx={{ fontSize: 16, color: "#1877F2" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>234</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Likes</Typography>
                                    </Typography>
                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 16, color: "#42B72A" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>23</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Comments</Typography>
                                    </Typography>

                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <ShareOutlinedIcon sx={{ fontSize: 16, color: "#F7B928" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>8</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Shares</Typography>
                                    </Typography>

                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <VisibilityOutlinedIcon sx={{ fontSize: 18, color: "#2E89A3" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>1.8K</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Reach</Typography>
                                    </Typography>
                                </Box>
                            </Box>

                            <Divider sx={{ my: 1.5 }} />

                            {/* Actions */}
                            <Box display="flex" gap={1}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#0098F6",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#0098F6", // slightly darker blue
                                        },
                                    }}
                                >
                                    View on Facebook
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#7993B1",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#7993B1", // slightly darker blue
                                        },
                                    }}
                                >
                                    Analytics
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#F06948",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#F06948", // slightly darker blue
                                        },
                                    }}
                                >
                                    Repost
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#FF6868",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#FF6868", // slightly darker blue
                                        },
                                    }}
                                >
                                    Delete
                                </Button>
                            </Box>
                        </Card>
                    </Box>
                   <Box>
                        <Card
                            sx={{
                                width: "100%",
                                boxShadow: "0px 0px 4px 0px #0000001F",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "12px",
                                padding: "20px",
                                p: 2,
                            }}
                        >
                            {/* Header */}
                            <Box display="flex" alignItems="center" gap={2}>
                                <Box style={{
                                    width: "70px",
                                    height: "70px",
                                    borderRadius: "11px",
                                    backgroundColor: "#D9D9D9",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    image
                                </Box>
                                <Box flex={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography fontWeight={700} fontSize={16}>
                                            ✨ Premium Wireless Headphones ✨
                                        </Typography>

                                        <Chip
                                            label="Published"
                                            size="small"
                                            sx={{
                                                bgcolor: "#106C3647",
                                                color: "#106C36",
                                                fontWeight: 700,
                                                fontSize: 12,
                                                height: 26,
                                                p: 1,
                                            }}
                                        />
                                    </Box>

                                    {/* Description */}
                                    <Typography
                                        fontSize={14}
                                        fontWeight={700}
                                        mt={0.5}
                                        mb={1}
                                        lineHeight="18px"
                                    >
                                        Experience crystal-clear audio with our latest wireless headphones
                                        featuring active noise cancellation...
                                    </Typography>

                                    {/* Meta */}

                                    <Box
                                        fontWeight={600} color="#898989"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "16px",


                                        }}
                                    >
                                        {/* Date */}
                                        <Box display="flex" alignItems="center" gap="6px">
                                            <CalendarTodayOutlinedIcon sx={{ fontSize: 14 }} />
                                            <Typography fontSize={14}>
                                                Dec 11, 2025 · 10:30 AM
                                            </Typography>
                                        </Box>

                                        {/* Product */}
                                        <Box display="flex" alignItems="center" gap="6px">
                                            <Inventory2OutlinedIcon sx={{ fontSize: 14 }} />
                                            <Typography fontSize={14}>
                                                Product: Wireless Headphones
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Divider sx={{ my: 1.5 }} />

                            {/* Stats */}
                            <Box display="flex" alignItems="center" gap={2}>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <ThumbUpAltOutlinedIcon sx={{ fontSize: 16, color: "#1877F2" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>234</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Likes</Typography>
                                    </Typography>
                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 16, color: "#42B72A" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>23</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Comments</Typography>
                                    </Typography>

                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <ShareOutlinedIcon sx={{ fontSize: 16, color: "#F7B928" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>8</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Shares</Typography>
                                    </Typography>

                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <VisibilityOutlinedIcon sx={{ fontSize: 18, color: "#2E89A3" }} />
                                    <Typography display="flex" alignItems="center" gap={0.5}>
                                        <Typography fontSize={13} fontWeight={800}>1.8K</Typography>
                                        <Typography fontSize={13} color="#898989" fontWeight={800}>Reach</Typography>
                                    </Typography>
                                </Box>
                            </Box>

                            <Divider sx={{ my: 1.5 }} />

                            {/* Actions */}
                            <Box display="flex" gap={1}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#0098F6",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#0098F6", // slightly darker blue
                                        },
                                    }}
                                >
                                    View on Facebook
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#7993B1",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#7993B1", // slightly darker blue
                                        },
                                    }}
                                >
                                    Analytics
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#F06948",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#F06948", // slightly darker blue
                                        },
                                    }}
                                >
                                    Repost
                                </Button>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        bgcolor: "#FF6868",
                                        textTransform: "none",
                                        fontSize: 13,
                                        px: 2,
                                        "&:hover": {
                                            bgcolor: "#FF6868", // slightly darker blue
                                        },
                                    }}
                                >
                                    Delete
                                </Button>
                            </Box>
                        </Card>
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}

export default FacebookPosts;